export default __webpack_public_path__ + "static/media/Snd2.f77a7328.mp3";